import { render, staticRenderFns } from "./Kifus.vue?vue&type=template&id=36acf09a&scoped=true&"
import script from "./Kifus.vue?vue&type=script&lang=js&"
export * from "./Kifus.vue?vue&type=script&lang=js&"
import style0 from "./Kifus.vue?vue&type=style&index=0&id=36acf09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36acf09a",
  null
  
)

export default component.exports